/* eslint-disable @next/next/no-img-element */
import { Badge } from 'antd'
import { useQuery, useQueryClient } from 'react-query'
import { GET_CART } from '~src/api/cart'
import { graphQLClient } from '~src/api/graphql'

export const CartCount = () => {
  const queryClient = useQueryClient()
  const { data: dataCart } = useQuery({
    queryKey: ['getCartId'],
    queryFn: async () => {
      if (!localStorage.getItem('cartId')) return
      const data = (await graphQLClient.request(GET_CART, {
        cart_id: localStorage.getItem('cartId'),
      })) as TDataUpdateToCart
      return data
    },
    cacheTime: Infinity,
    enabled: true,
  })

  return (
    <button
      className="flex max-md:bg-[#e7e5e5] max-md:rounded-full max-md:w-[3.6rem] max-md:h-[3.6rem] max-md:flex max-md:items-center max-md:justify-center "
      onClick={() => queryClient.setQueryData<boolean>('miniCartVisible', (visible) => !visible)}
    >
      <Badge
        color="#c82127"
        count={dataCart?.cart?.items?.length || 0}
        size="small"
        overflowCount={9}
      >
        <div className="img min-w-[12px] w-[2rem]">
          <img src={'/image/svg/shopping-cart.svg'} alt="" className="w-full" />
        </div>
      </Badge>
    </button>
  )
}
